import { toast } from "../ui/toast";
import { Feature, MORE_ORDER } from "./registry";

/** What one tap grants: enough for builder 2 and a Black Market Legendary, or a couple of Trading Post buys. */
const DEBUG_GEMS = 500;
const DEBUG_MARKS = 500;

/**
 * Debug only (`?debug` or a dev build): a More row that grants gems and Marks into the wallet (reason `debug`), so the
 * economy (FINISH_PLAN WP1) can be tried before its Shop and Market screens land (WP5). Real gem packs go through the
 * Store port (@highmarch/app PurchaseService), never through here.
 */
export const walletDebugFeature: Feature = {
  id: "walletDebug",
  register(ctx, registry) {
    const wallet = () => ctx.catalog.economy.wallet;
    registry.moreRow({
      id: "walletDebug", order: MORE_ORDER.debug + 1, icon: "coin",
      label: () => `Debug: +${DEBUG_GEMS} gems, +${DEBUG_MARKS} Marks`,
      note: () => `${wallet().gems} gems · ${wallet().marks} Marks`,
      visible: () => ctx.debug,
      open: (hub) => {
        const now = ctx.now();
        wallet().grant("gems", DEBUG_GEMS, "debug", now);
        wallet().grant("marks", DEBUG_MARKS, "debug", now);
        hub.changed();
        toast(hub.parent, `${wallet().gems} gems · ${wallet().marks} Marks`);
      },
    });
  },
};
